// Claims stay inside the custom-trophy boundaries in .seo/truth.md: prices come
// from ./custom-trophy pricing (one source), no fixed turnaround or rush promise,
// plating is not solid metal. Buyer questions come from real league inquiries
// (Sep–Oct 2026) and the 2026-10-29 AI-visibility prompts #1, #3 and #8.
const { pricing } = require('./custom-trophy')

const [paintedTier, platedTier] = pricing.tiers

const fantasyTrophy = {
  path: '/services/custom-trophy/fantasy-football/',
  reviewedDate: '2026-10-29',
  reviewedDateLabel: 'October 29, 2026',
  title: 'Custom Fantasy Football Trophies | PrintAWorld',
  description: `One-of-a-kind fantasy football and league trophies, 3D printed in New York from your idea. From $${pricing.from}, free mockup, nameplates for every season.`,
  answer: `PrintAWorld makes one-of-a-kind, 3D printed fantasy football trophies in New York. Send a photo, a sketch, an AI-generated image or your league’s inside joke; we model it in 3D, print it, paint or plate it, and mount it on a base with room for every champion’s name. Trophies start at $${pricing.from}, there’s no minimum, and we ship anywhere in the U.S.`,
}

const ideas = [
  {
    title: 'The championship pose',
    body: 'A player’s touchdown celebration, or your commissioner striking it, sculpted as the topper. Send a photo of the pose and we build it from that.',
  },
  {
    title: 'The league’s inside joke',
    body: 'The team name, the trash-talk mascot, the trade nobody forgives. If the league already has a running joke, it makes the best trophy.',
  },
  {
    title: 'The perpetual trophy',
    body: 'A fantasy football perpetual trophy changes hands every season, on a base with name plates for each year’s champion and room left for the next ones. Some leagues pass a belt instead.',
    link: ['Championship belts', '/services/custom-trophy/championship-belt/'],
  },
  {
    title: 'The last-place trophy',
    body: 'The loser trophy, the toilet bowl, the one nobody wants to win. Plenty of leagues want one, and it follows the same process as the champion’s, at whatever size and finish you choose.',
    link: [
      'Last-place punishment ideas',
      '/guides/fantasy-football-punishments/',
    ],
  },
  {
    title: 'Mini copies for every champion',
    body: 'A desk-sized copy of the main trophy for each year’s winner to keep, while the big one stays with the league. We can work from the original or from photos.',
  },
  {
    title: 'Matching league awards',
    body: 'One design with different names: champion, runner-up, rookie of the year. You pay the 3D modeling fee once for the whole set.',
  },
]

const leagues = [
  'Fantasy football',
  'Fantasy basketball and baseball',
  'Hockey and rec leagues',
  'Golf outings and tournaments',
  'Office and bar leagues',
  'Esports and gaming leagues',
]

const faqs = [
  {
    question: 'How much does a custom fantasy football trophy cost?',
    answer: `Custom fantasy trophies start at $${pricing.from}. Most painted resin trophies 8–12 inches tall cost ${paintedTier.price}; plated, gold or larger trophies run ${platedTier.price}, and anything 16 inches or taller starts at $1,500. Each new design adds a one-time 3D modeling fee, $${pricing.modelingFee} for most projects, and the concept mockup is free.`,
  },
  {
    question:
      'Can you put a real player’s pose or our league joke on the trophy?',
    answer:
      'Yes. Send photos of the pose or the joke and we sculpt it in 3D as the topper. A likeness of a real person takes more modeling and finishing than a logo, which the quote reflects.',
  },
  {
    question: 'Can I send an AI-generated image of the trophy?',
    answer:
      'Yes. Send the AI image with your quote request and we model the trophy in 3D from it, then send you the model to approve before printing. Images that show one trophy on a plain background, with thick shapes, two or three solid colors and no text, come out closest to the picture. Crystal, glass and glowing effects can’t be made.',
  },
  {
    question: 'Can the trophy have name plates for future champions?',
    answer:
      'Yes. Tell us it’s a perpetual trophy and we size the base for engraved nameplates, one per season, with blank plates or space left for the years ahead.',
  },
  {
    question: 'When should we order for our championship or draft?',
    answer:
      'As soon as you know the date. A month or more leaves room for the mockup, your approval of the 3D model, and finishing. If your date is closer, ask anyway and we’ll tell you what size and finish fit the time.',
  },
  {
    question: 'Is a gold fantasy trophy solid metal?',
    answer:
      'No. A gold or chrome finish is a real metal layer plated over the printed trophy. It looks and feels like metal without the weight or cost of cast metal.',
  },
  {
    question: 'Can you make just one?',
    answer:
      'Yes. Most leagues order one trophy, and there is no minimum order. If you want a champion and a last-place trophy, or awards for several categories, we quote the set together.',
  },
  {
    question: 'Do you ship to our league?',
    answer:
      'Yes, anywhere in the United States. Pickup from our New York studio is available by appointment.',
  },
]

module.exports = { fantasyTrophy, ideas, leagues, faqs }
